export const columns = [
    { 
      field: 'file', 
      header: 'Legajo'
    },
    {
      field: 'name',
      header: 'Nombre'
    },
    {
      field: 'totalAmount',
      header: 'Importe',
      type: 'money'
    },
    {
      field: 'quantity',
      header: 'Tickets',
    },
];